import React, { useState, useEffect, useRef } from 'react';
import { getSingleUser, updateUserImage } from '../../api/axios';
import { jwtDecode } from 'jwt-decode';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Avatar, Button, Stack } from '@mui/material';
import Slider from 'react-slick';

const HeadshotUpload = ({ userId }) => {
  const [imageURL, setImageURL] = useState('https://talent.kidscasting.com/assets/placeholders/circle-male-close_up.svg');
  // console.log('imageURL: ', imageURL);
  const [selectedImage, setSelectedImage] = useState(null);

  const [crop, setCrop] = useState(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  const token = localStorage.getItem('token');
  const decodedToken = jwtDecode(token);
  const UserId = decodedToken.userId;

  useEffect(() => {
    const fetchUserImage = async () => {
      try {
        const userData = await getSingleUser(userId);
        setImageURL(userData?.user?.imageURL);
      } catch (error) {
        console.error('Error fetching user image:', error);
      }
    };

    fetchUserImage();
  }, [userId,imageURL]);

  
  useEffect(() => {
    const handleKeyDown = async (event) => {
      if (event.key === 'Enter' && selectedImage) {
        event.preventDefault();
        await handleUpload();
      } else if (event.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage]);

  const onSelectFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setSelectedImage(reader.result));
      reader.readAsDataURL(file);
    }
  };

   

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    setCrop(
      centerCrop(
        makeAspectCrop({ unit: '%', width: 80 }, 1, width, height),
        width,
        height
      )
    );
  };

  const getCroppedImage = async () => {
    if (!previewCanvasRef.current || !completedCrop || !imgRef.current) return;

    const canvas = previewCanvasRef.current;
    const image = imgRef.current;
    const ctx = canvas.getContext('2d');

    if (!image.complete) {
      console.error('Image is not fully loaded.');
      return;
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const cropX = completedCrop.x * scaleX;
    const cropY = completedCrop.y * scaleY;
    const cropWidth = completedCrop.width * scaleX;
    const cropHeight = completedCrop.height * scaleY;

    canvas.width = cropWidth;
    canvas.height = cropHeight;

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg');
    });
  };

  const handleUpload = async () => {
    const croppedBlob = await getCroppedImage();
    if (croppedBlob) {
      const formData = new FormData();
      formData.append('imageURL', croppedBlob, 'cropped-image.jpg');
      // console.log('Appended image form Data', formData);

      try {
        await updateUserImage(userId, formData);
 
        const updatedUserData = await getSingleUser(userId);
        setImageURL(updatedUserData.user.imageURL);
        setSelectedImage(null); // Close crop popup after upload
      } catch (error) {
        console.error('Error uploading cropped image:', error);
      }
    }
  };

  const handleCancel = () => {
    setSelectedImage(null);
    setCrop(null);
    setCompletedCrop(null);
  };

  console.log('Rendering HeadshotUpload - imageURL:', imageURL);
  return (
    <div className='headshot-upload-wrapper'>
      <div className='log-profile-topic' style={{ color: '#6E0506' }}>
        Headshot
      </div>
      <div className='log-profile-headshot'>
        {selectedImage ? (
          <>
            <div className='crop-container'>
              <ReactCrop
                crop={crop}
                onChange={(newCrop) => setCrop(newCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={1}
              >
                <img
                  ref={imgRef}
                  src={selectedImage}
                  alt='Crop'
                  onLoad={onImageLoad}
                  crossOrigin='anonymous' // Add this if needed
                />
              </ReactCrop>
              <Stack spacing={2} direction='row' justifyContent='center'>
                <Button onClick={handleUpload} variant='text' color='success'>
                  Submit
                </Button>
                <Button onClick={handleCancel} variant='text' color='error'>
                  Cancel
                </Button>
              </Stack>
              {/* <div className="crop-buttons">
                <button onClick={handleUpload} className="submit-button">
                  Submit
                </button>
                <button onClick={handleCancel} className="cancel-button">
                  Cancel
                </button>
              </div> */}
            </div>
            <canvas ref={previewCanvasRef} style={{ display: 'none' }} />
          </>
        ) : (
          <>
            <img src={imageURL} alt='Headshot' className='headshot-img' />
            <input
              type='file'
              accept='image/*'
              onChange={onSelectFile}
              style={{ display: 'none' }}
              id='headshot-upload'
            />
            <label htmlFor='headshot-upload' className='headshot-upload-button'>
              Upload New Image
            </label>
          </>
        )}
        
        
      </div>
    </div>
  );
};

export default HeadshotUpload;
